var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlasshour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_glasshour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Booking",
    transform: "translate(-201.000000, -468.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(155.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(26.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_glasshour",
    transform: "translate(20.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,30 C23.2842712,30 30,23.2842712 30,15 C30,6.71572875 23.2842712,0 15,0 C6.71572875,0 0,6.71572875 0,15 C0.00895605952,23.2805587 6.71944131,29.9910439 15,30 Z",
    id: "Shape",
    fill: "#BFC4CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.95,22.4 L19.9,22.4 L19.9,19.95 C19.8982859,17.9468376 18.6791407,16.1458275 16.82,15.4 C18.6790139,14.6540154 19.898093,12.8531031 19.9,10.85 L19.9,8.4 L20.95,8.4 C21.3365993,8.4 21.65,8.08659932 21.65,7.7 C21.65,7.31340068 21.3365993,7 20.95,7 L9.05,7 C8.66340068,7 8.35,7.31340068 8.35,7.7 C8.35,8.08659932 8.66340068,8.4 9.05,8.4 L10.1,8.4 L10.1,10.85 C10.101907,12.8531031 11.3209861,14.6540154 13.18,15.4 C11.3208593,16.1458275 10.1017141,17.9468376 10.1,19.95 L10.1,22.4 L9.05,22.4 C8.66340068,22.4 8.35,22.7134007 8.35,23.1 C8.35,23.4865993 8.66340068,23.8 9.05,23.8 L20.95,23.8 C21.3365993,23.8 21.65,23.4865993 21.65,23.1 C21.65,22.7134007 21.3365993,22.4 20.95,22.4 Z M12.333,11.844 C12.4527748,11.6102344 12.693336,11.4632 12.956,11.4632 L17.044,11.4632 C17.3065441,11.4633978 17.546903,11.6104908 17.6665535,11.8441855 C17.7862041,12.0778802 17.7650259,12.3588788 17.6117,12.572 C17.0081189,13.4137785 16.0358094,13.9130306 15,13.9130306 C13.9641906,13.9130306 12.9918811,13.4137785 12.3883,12.572 C12.2347554,12.3589227 12.2134028,12.0778255 12.333,11.844 L12.333,11.844 Z M12.144,20.041 L14.2748,17.9858 C14.6862831,17.6140869 15.3123169,17.6140869 15.7238,17.9858 L15.7238,17.9858 L17.8539,20.0403 C18.1592452,20.3299545 18.2360389,20.7867202 18.0422,21.1603 C17.8627159,21.4953159 17.5122529,21.7031674 17.1322,21.7 L12.8699,21.7 C12.4908597,21.7042898 12.1405805,21.4984334 11.9599,21.1652 C11.7636112,20.7913564 11.8387202,20.3327063 12.144,20.041 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlasshour);
export default __webpack_public_path__ + "static/media/icon_glasshour.54c1b5a8cadc343870dd95b216329b5f.svg";
export { ForwardRef as ReactComponent };